import { takeEvery } from '@zaibot/fsa-saga';
import { fork } from '../redux-saga';
import userManager from './userManager';

import LOGIN from './actions/LOGIN';
import LOGOUT from './actions/LOGOUT';

export default function* rootSaga(): Iterable<any> {
    yield fork(monitorLoggedOut);
    yield fork(monitorLogin);
    yield fork(monitorLogout);
}

function* monitorLoggedOut() {
    yield userManager(async (um) => await um.signoutRedirectCallback().then((response) => {
        if (response && response.state) {
            window.location.href = response.state.url;
        } else if (window.sessionStorage.getItem(`__appredirecturl`)) {
            const url = window.sessionStorage.getItem(`__appredirecturl`);
            window.sessionStorage.removeItem(`__appredirecturl`);
            window.location.href = url;
        }
    }, (err) => {
        // Nothing, user hasn't logged out
    }));
}

function* monitorLogin() {
    yield takeEvery(LOGIN, function*() {
        yield userManager(async (um) => { 
            await um.signinRedirect({ state: { url: window.location.href } });
        });
    });
}

function* monitorLogout() {
    yield takeEvery(LOGOUT, function*() {
        window.sessionStorage[`__appredirecturl`] = window.location.href;
        yield userManager(async (um) => await um.signoutRedirect({ state: { url: window.location.href } }));
    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/auth/saga.tsx